import React, { useState, useEffect } from 'react';
import { getQaList, updateQaList } from '../../../Api/apiUtils';
import { useNavigate } from "react-router-dom";

import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { User, MessageSquare, Clock, File, MessageCircle, UserMinus, Headphones, UserCheck, ArrowLeft } from 'react-feather';
import { toast } from 'react-toastify';
import { MixpanelEvents, trackEvent } from '../../../utils/mixpanelTracking';
import { Page, PageHeader, Card, Button, Field, TextInput, Table, Loader, EmptyState } from '../../../ui';
import './qaPolicy.scss';


const GetQaList: React.FC = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<any>([]);
  const [openCollapseId, setOpenCollapseId] = useState<string | null>(null);
  const [editedData, setEditedData] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    fetchQaListData();
  }, []);

  const fetchQaListData = async () => {
    setIsLoading(true);
    try {
      const response = await getQaList();
      const parsedData = response.map((item: any) => ({
        ...item,
        qaDetails: JSON.parse(item.qaDetails),
      }));
      setData(parsedData);
      console.log("API Response:", parsedData);
    } catch (error) {
      console.error("Error fetching QA list:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleCollapse = (id: string) => {
    setOpenCollapseId(openCollapseId === id ? null : id);
  };

  // Utility function to get edited value or fallback
  function getEditedValue(editedData: any, id: string, path: string, fallback: any) {
    const keys = path.split(".");
    let value = editedData[id];
    for (let key of keys) {
      if (value && value.hasOwnProperty(key)) {
        value = value[key];
      } else {
        return fallback;
      }
    }
    return value;
  }

  const handleInputChange = (id: string, fieldPath: string, value: string) => {
    const fields = fieldPath.split('.');
    setEditedData((prev: any) => {
      const updatedData = { ...prev };
      if (!updatedData[id]) {
        updatedData[id] = {};
      }
  
      let currentLevel = updatedData[id];
      for (let i = 0; i < fields.length - 1; i++) {
        if (!currentLevel[fields[i]]) {
          currentLevel[fields[i]] = {};
        }
        currentLevel = currentLevel[fields[i]];
      }
  
      currentLevel[fields[fields.length - 1]] = value; // Set final value
  
      return updatedData;
    });
  };
 const handleSave = async (id: string) => {
  try {
    const teacherIndex = data.findIndex((teacher: any) => teacher.id === id);
    if (teacherIndex === -1) {
      console.error("Teacher not found");
      return;
    }

    const teacher = data[teacherIndex];
    const qaDetails = teacher.qaDetails;
    const payload = {
      teacherId: qaDetails.teacherId,
      teacherName: qaDetails.teacherName,
      teacherCategory: qaDetails.teacherCategory,
      studentName: qaDetails.studentName,
      sessionDate: teacher.sessionDate || "",
      course: qaDetails.course || "",
      ageGroup: qaDetails.ageGroup || "",
      auditDate: teacher.auditDate || "",
      feedbackStatus: getEditedValue(editedData, id, 'feedbackStatus', qaDetails.feedbackStatus || ""),
      feedbackLink: getEditedValue(editedData, id, 'feedbackLink', qaDetails.feedbackLink || ""),
      observation: getEditedValue(editedData, id, 'observation', qaDetails.observation || ""),
      qaScore: getEditedValue(editedData, id, 'qaScore', teacher.qaScore || "0"),
      payload: [
        {
          Opening: {
            startedOnTime: getEditedValue(editedData, id, 'startedOnTime', qaDetails.payload?.[0]?.Opening?.startedOnTime ?? ""),
            internetConnection: getEditedValue(editedData, id, 'internetConnection', qaDetails.payload?.[0]?.Opening?.internetConnection ?? ""),
            greetingIntroduction: getEditedValue(editedData, id, 'greetingIntroduction', qaDetails.payload?.[0]?.Opening?.greetingIntroduction ?? ""),
          },
          Feedback: {
            constructiveFeedbackWhileDiscussingTheAssessmentAssignmentOfThePreviousClass: getEditedValue(editedData, id, 'constructiveFeedbackWhileDiscussingTheAssessmentAssignmentOfThePreviousClass', qaDetails.payload?.[0]?.Feedback?.constructiveFeedbackWhileDiscussingTheAssessmentAssignmentOfThePreviousClass ?? ""),
            aOIWithExamples: getEditedValue(editedData, id, 'aOIWithExamples', qaDetails.payload?.[0]?.Feedback?.aOIWithExamples ?? ""),
            addressTheStudentByTheirName: getEditedValue(editedData, id, 'addressTheStudentByTheirName', qaDetails.payload?.[0]?.Feedback?.addressTheStudentByTheirName ?? ""),
          },
          RapportBuilding: {
            engagementLevel: getEditedValue(editedData, id, 'RapportBuilding.engagementLevel', qaDetails.payload?.[0]?.RapportBuilding?.engagementLevel ?? ""),
            madeTheStudentFeelComfortable: getEditedValue(editedData, id, 'RapportBuilding.madeTheStudentFeelComfortable', qaDetails.payload?.[0]?.RapportBuilding?.madeTheStudentFeelComfortable ?? ""),
          },
          communicationSkillsAndSoftskills: {
            deadAirFumblingFillersUnnecessaryMuteNeedsToBeAvoided: getEditedValue(editedData, id, 'communicationSkillsAndSoftskills.deadAirFumblingFillersUnnecessaryMuteNeedsToBeAvoided', qaDetails.payload?.[0]?.communicationSkillsAndSoftskills?.deadAirFumblingFillersUnnecessaryMuteNeedsToBeAvoided ?? ""),
            casualApproachToneUsageOfSlangLanguage: getEditedValue(editedData, id, 'communicationSkillsAndSoftskills.casualApproachToneUsageOfSlangLanguage', qaDetails.payload?.[0]?.communicationSkillsAndSoftskills?.casualApproachToneUsageOfSlangLanguage ?? ""),
            acknowledgment: getEditedValue(editedData, id, 'communicationSkillsAndSoftskills.acknowledgment', qaDetails.payload?.[0]?.communicationSkillsAndSoftskills?.acknowledgment ?? ""),
            activeListening: getEditedValue(editedData, id, 'communicationSkillsAndSoftskills.activeListening', qaDetails.payload?.[0]?.communicationSkillsAndSoftskills?.activeListening ?? ""),
            interruption: getEditedValue(editedData, id, 'communicationSkillsAndSoftskills.interruption', qaDetails.payload?.[0]?.communicationSkillsAndSoftskills?.interruption ?? ""),
            energyLevel: getEditedValue(editedData, id, 'communicationSkillsAndSoftskills.energyLevel', qaDetails.payload?.[0]?.communicationSkillsAndSoftskills?.energyLevel ?? ""),
            rateOfSpeech: getEditedValue(editedData, id, 'communicationSkillsAndSoftskills.rateOfSpeech', qaDetails.payload?.[0]?.communicationSkillsAndSoftskills?.rateOfSpeech ?? ""),
          },
          Closing: {
            customerDelight: getEditedValue(editedData, id, 'Closing.customerDelight', qaDetails.payload?.[0]?.Closing?.customerDelight ?? ""),
            DoubtsSolvingQueryResolution: getEditedValue(editedData, id, 'Closing.DoubtsSolvingQueryResolution', qaDetails.payload?.[0]?.Closing?.DoubtsSolvingQueryResolution ?? ""),
            energeticAndPositiveClosing: getEditedValue(editedData, id, 'Closing.energeticAndPositiveClosing', qaDetails.payload?.[0]?.Closing?.energeticAndPositiveClosing ?? ""),
            disconnectionAfterTheStudent: getEditedValue(editedData, id, 'Closing.disconnectionAfterTheStudent', qaDetails.payload?.[0]?.Closing?.disconnectionAfterTheStudent ?? ""),
          },
          TechGadgets: {
            mic: getEditedValue(editedData, id, 'TechGadgets.mic', qaDetails.payload?.[0]?.TechGadgets?.mic ?? ""),
            headphones: getEditedValue(editedData, id, 'TechGadgets.headphones', qaDetails.payload?.[0]?.TechGadgets?.headphones ?? ""),
            jacket: getEditedValue(editedData, id, 'TechGadgets.jacket', qaDetails.payload?.[0]?.TechGadgets?.jacket ?? ""),
            videoQualityCamAngleBodyLanguageBackground: getEditedValue(editedData, id, 'TechGadgets.videoQualityCamAngleBodyLanguageBackground', qaDetails.payload?.[0]?.TechGadgets?.videoQualityCamAngleBodyLanguageBackground ?? ""),
            practiceStudio: getEditedValue(editedData, id, 'TechGadgets.practiceStudio', qaDetails.payload?.[0]?.TechGadgets?.practiceStudio ?? ""),
            pleaseSpecifyTheInstrumentUsed: getEditedValue(editedData, id, 'TechGadgets.pleaseSpecifyTheInstrumentUsed', qaDetails.payload?.[0]?.TechGadgets?.pleaseSpecifyTheInstrumentUsed ?? ""),
          },
          Presentation: {
            appropriatelyDressed: getEditedValue(editedData, id, 'Presentation.appropriatelyDressed', qaDetails.payload?.[0]?.Presentation?.appropriatelyDressed ?? ""),
            videoOn: getEditedValue(editedData, id, 'Presentation.videoOn', qaDetails.payload?.[0]?.Presentation?.videoOn ?? ""),
            rudeSarcasticIntimidatingBehaviourUnprofessionalism: getEditedValue(editedData, id, 'Presentation.rudeSarcasticIntimidatingBehaviourUnprofessionalism', qaDetails.payload?.[0]?.Presentation?.rudeSarcasticIntimidatingBehaviourUnprofessionalism ?? ""),
          },
          Time: {
            sessionAsPerStandardTime: getEditedValue(editedData, id, 'Time.sessionAsPerStandardTime', qaDetails.payload?.[0]?.Time?.sessionAsPerStandardTime ?? ""),
          },
        },
      ],
    };

    console.log("Updated Payload:", payload);

    await updateQaList(payload);
    await fetchQaListData();
    toast.success("QA List updated successfully");
    trackEvent(MixpanelEvents.QA_ADMIN_AUDIT_UPDATED, {
      source: "qa_policy_audit_list",
      auditId: id != null ? String(id) : undefined,
      teacherId: payload?.teacherId != null ? String(payload.teacherId) : undefined,
    });
    setEditedData((prev: any) => {
      const newData = { ...prev };
      delete newData[id];
      return newData;
    });
  } catch (error) {
    toast.error("Error updating QA list");
    trackEvent(MixpanelEvents.QA_ADMIN_AUDIT_UPDATE_FAILED, {
      source: "qa_policy_audit_list",
      auditId: id != null ? String(id) : undefined,
    });
  }
};

const handleEdit = (teacher:any) => {
  setSelectedTeacher(teacher);
  setIsModalOpen(true);
};

  // Edit-modal sections. `path` is the editedData key handleInputChange/handleSave use;
  // `read` is the saved value shown until the field is edited.
  const p0 = (teacher: any) => teacher.qaDetails.payload?.[0];
  const editSections: {
    title: string;
    icon: React.ReactNode;
    fields: { label: string; path: string; read: (teacher: any) => any; textarea?: boolean; full?: boolean }[];
  }[] = [
    {
      title: 'Basic Information',
      icon: <User size={18} aria-hidden />,
      fields: [
        { label: 'Feedback Status', path: 'feedbackStatus', read: (t) => t.qaDetails.feedbackStatus },
        { label: 'Feedback Link', path: 'feedbackLink', read: (t) => t.qaDetails.feedbackLink },
        { label: 'Observation', path: 'observation', read: (t) => t.qaDetails.observation, textarea: true, full: true },
      ],
    },
    {
      title: 'Opening',
      icon: <Clock size={18} aria-hidden />,
      fields: [
        { label: 'Started on Time', path: 'startedOnTime', read: (t) => p0(t)?.Opening?.startedOnTime ?? "" },
        { label: 'Internet Connection', path: 'internetConnection', read: (t) => p0(t)?.Opening?.internetConnection ?? "" },
        { label: 'Greeting/Introduction', path: 'greetingIntroduction', read: (t) => p0(t)?.Opening?.greetingIntroduction ?? "" },
      ],
    },
    {
      title: 'Feedback',
      icon: <MessageSquare size={18} aria-hidden />,
      fields: [
        {
          label: 'Assignment of the Previous Class',
          path: 'constructiveFeedbackWhileDiscussingTheAssessmentAssignmentOfThePreviousClass',
          read: (t) => p0(t)?.Feedback?.constructiveFeedbackWhileDiscussingTheAssessmentAssignmentOfThePreviousClass ?? "",
        },
        { label: 'AOI with Examples', path: 'aOIWithExamples', read: (t) => p0(t)?.Feedback?.aOIWithExamples ?? "" },
        { label: 'Address the Student by Their Name', path: 'addressTheStudentByTheirName', read: (t) => p0(t)?.Feedback?.addressTheStudentByTheirName ?? "" },
      ],
    },
    {
      title: 'Rapport Building',
      icon: <File size={18} aria-hidden />,
      fields: [
        { label: 'Engagement Level', path: 'RapportBuilding.engagementLevel', read: (t) => p0(t)?.RapportBuilding?.engagementLevel ?? "" },
        { label: 'Made the Student Feel Comfortable', path: 'RapportBuilding.madeTheStudentFeelComfortable', read: (t) => p0(t)?.RapportBuilding?.madeTheStudentFeelComfortable ?? "" },
      ],
    },
    {
      title: 'Communication Skills and Soft Skills',
      icon: <MessageCircle size={18} aria-hidden />,
      fields: [
        {
          label: 'Dead Air/Fumbling/Fillers/Unnecessary Mute Needs to be Avoided',
          path: 'communicationSkillsAndSoftskills.deadAirFumblingFillersUnnecessaryMuteNeedsToBeAvoided',
          read: (t) => p0(t)?.communicationSkillsAndSoftskills?.deadAirFumblingFillersUnnecessaryMuteNeedsToBeAvoided ?? "",
        },
        {
          label: 'Casual Approach/Tone, Usage of Slang Language',
          path: 'communicationSkillsAndSoftskills.casualApproachToneUsageOfSlangLanguage',
          read: (t) => p0(t)?.communicationSkillsAndSoftskills?.casualApproachToneUsageOfSlangLanguage ?? "",
        },
        { label: 'Acknowledgment', path: 'communicationSkillsAndSoftskills.acknowledgment', read: (t) => p0(t)?.communicationSkillsAndSoftskills?.acknowledgment ?? "" },
        { label: 'Active Listening', path: 'communicationSkillsAndSoftskills.activeListening', read: (t) => p0(t)?.communicationSkillsAndSoftskills?.activeListening ?? "" },
        { label: 'Interruption', path: 'communicationSkillsAndSoftskills.interruption', read: (t) => p0(t)?.communicationSkillsAndSoftskills?.interruption ?? "" },
        { label: 'Energy Level', path: 'communicationSkillsAndSoftskills.energyLevel', read: (t) => p0(t)?.communicationSkillsAndSoftskills?.energyLevel ?? "" },
        { label: 'Rate of Speech', path: 'communicationSkillsAndSoftskills.rateOfSpeech', read: (t) => p0(t)?.communicationSkillsAndSoftskills?.rateOfSpeech ?? "" },
      ],
    },
    {
      title: 'Closing',
      icon: <UserMinus size={18} aria-hidden />,
      fields: [
        { label: 'Customer Delight', path: 'Closing.customerDelight', read: (t) => p0(t)?.Closing?.customerDelight ?? "" },
        { label: 'Doubts Solving/Query Resolution', path: 'Closing.DoubtsSolvingQueryResolution', read: (t) => p0(t)?.Closing?.DoubtsSolvingQueryResolution ?? "" },
        { label: 'Energetic and Positive Closing', path: 'Closing.energeticAndPositiveClosing', read: (t) => p0(t)?.Closing?.energeticAndPositiveClosing ?? "" },
        { label: 'Disconnection after the Student', path: 'Closing.disconnectionAfterTheStudent', read: (t) => p0(t)?.Closing?.disconnectionAfterTheStudent ?? "" },
      ],
    },
    {
      title: 'Tech & Gadgets',
      icon: <Headphones size={18} aria-hidden />,
      fields: [
        { label: 'Mic', path: 'TechGadgets.mic', read: (t) => p0(t)?.TechGadgets?.mic ?? "" },
        { label: 'Headphones', path: 'TechGadgets.headphones', read: (t) => p0(t)?.TechGadgets?.headphones ?? "" },
        { label: 'Jacket', path: 'TechGadgets.jacket', read: (t) => p0(t)?.TechGadgets?.jacket ?? "" },
        {
          label: 'Video Quality/Cam Angle/Body Language/Background',
          path: 'TechGadgets.videoQualityCamAngleBodyLanguageBackground',
          read: (t) => p0(t)?.TechGadgets?.videoQualityCamAngleBodyLanguageBackground ?? "",
        },
        { label: 'Practice Studio', path: 'TechGadgets.practiceStudio', read: (t) => p0(t)?.TechGadgets?.practiceStudio ?? "" },
        { label: 'Instrument Used', path: 'TechGadgets.pleaseSpecifyTheInstrumentUsed', read: (t) => p0(t)?.TechGadgets?.pleaseSpecifyTheInstrumentUsed ?? "" },
      ],
    },
    {
      title: 'Presentation',
      icon: <UserCheck size={18} aria-hidden />,
      fields: [
        { label: 'Appropriately Dressed', path: 'Presentation.appropriatelyDressed', read: (t) => p0(t)?.Presentation?.appropriatelyDressed ?? "" },
        { label: 'Video On', path: 'Presentation.videoOn', read: (t) => p0(t)?.Presentation?.videoOn ?? "" },
        {
          label: 'Rude/Sarcastic/Intimidating Behaviour/Unprofessionalism',
          path: 'Presentation.rudeSarcasticIntimidatingBehaviourUnprofessionalism',
          read: (t) => p0(t)?.Presentation?.rudeSarcasticIntimidatingBehaviourUnprofessionalism ?? "",
        },
      ],
    },
    {
      title: 'Time',
      icon: <Clock size={18} aria-hidden />,
      fields: [
        { label: 'Session as per Standard Time', path: 'Time.sessionAsPerStandardTime', read: (t) => p0(t)?.Time?.sessionAsPerStandardTime ?? "" },
        { label: 'Observation', path: 'observation', read: (t) => t.qaDetails.observation },
        { label: 'QA Score', path: 'qaScore', read: (t) => t.qaScore },
      ],
    },
  ];

  return (
    <Page>
      <PageHeader
        eyebrow="Teacher Operations"
        title="QA Audit List"
        subtitle={isLoading ? 'Loading audits…' : `${data.length} audits`}
        actions={
          <Button variant="secondary" icon={<ArrowLeft size={16} aria-hidden />} onClick={() => navigate("/pages/qa-policy")}>
            Back
          </Button>
        }
      />

      {isLoading ? (
        <Loader label="Loading audits…" />
      ) : data.length === 0 ? (
        <EmptyState title="No audits yet" description="Audits added from Add Audit List show up here." />
      ) : (
        <Card flush>
          <Table caption="QA audits">
            <thead>
              <tr>
                <th>Teacher Name</th>
                <th>Teacher Category</th>
                <th>Student Name</th>
                <th>Age Group</th>
                <th>Course</th>
                <th>Session Date</th>
                <th>Audit Date</th>
                {/* <th>Actions</th> */}
              </tr>
            </thead>
            <tbody>
              {data.map((teacher: any) => (
                <tr key={teacher.id}>
                  <td>
                    <Button variant="ghost" size="sm" onClick={() => toggleCollapse(teacher.id)}>
                      {teacher.qaDetails.teacherName}
                    </Button>
                  </td>
                  <td>{teacher.qaDetails.teacherCategory}</td>
                  <td>{teacher.qaDetails.studentName}</td>
                  <td>{teacher.qaDetails.ageGroup}</td>
                  <td>{teacher.qaDetails.course}</td>
                  <td>{teacher.sessionDate}</td>
                  <td>{teacher.auditDate}</td>
                  {/* <td>
                    <Button variant="secondary" size="sm" onClick={() => handleEdit(teacher)}>Edit</Button>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </Table>
        </Card>
      )}

      <Modal isOpen={isModalOpen} toggle={() => setIsModalOpen(false)} size="lg">
        <ModalHeader toggle={() => setIsModalOpen(false)}>Edit Teacher</ModalHeader>
        <ModalBody>
          {data.map((teacher: any) => (
            <div className="qa-edit" key={teacher.id}>
              {editSections.map((section) => (
                <Card
                  key={section.title}
                  title={<span className="qa-section-title">{section.icon}{section.title}</span>}
                >
                  <div className="qa-grid">
                    {section.fields.map((f) => (
                      <Field key={f.path + f.label} label={f.label} className={f.full ? 'qa-grid__full' : undefined}>
                        {(ctl) =>
                          f.textarea ? (
                            <textarea
                              {...ctl}
                              className="ds-input qa-textarea"
                              value={getEditedValue(editedData, teacher.id, f.path, f.read(teacher))}
                              onChange={(e) => handleInputChange(teacher.id, f.path, e.target.value)}
                            />
                          ) : (
                            <TextInput
                              {...ctl}
                              type="text"
                              value={getEditedValue(editedData, teacher.id, f.path, f.read(teacher))}
                              onChange={(e) => handleInputChange(teacher.id, f.path, e.target.value)}
                            />
                          )
                        }
                      </Field>
                    ))}
                  </div>
                </Card>
              ))}
              <div className="qa-edit__actions">
                <Button variant="primary" onClick={() => handleSave(teacher.id)}>
                  Save
                </Button>
              </div>
            </div>
          ))}
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={() => setIsModalOpen(false)}>Close</Button>
        </ModalFooter>
      </Modal>
    </Page>
  );
};

export default GetQaList;